module.exports = __webpack_public_path__ + "9d768018557cee78efb62413d5fc22b3.png";